import Modal from '../../../components/UI/Modals/Modal';
import { useTranslation } from '../../../hooks/useTranslations';
import Html5QrcodePlugin from '../../Diagnostics/Html5QrcodePlugin';
import classes from './ScanSampleBarcodeModal.module.css';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccessScan: any;
  openManual: () => void;
};
const ScanSampleBarcodeModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSuccessScan,
  openManual,
}) => {
  const { translations } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={translations('scan.qr.code').toString()}
      divider
      containerPadding={'40px'}
    >
      <div className={classes.modalContent}>
        {isOpen && (
          <div className={classes.modalContentCamera}>
            <Html5QrcodePlugin
              fps={10}
              qrbox={250}
              disableFlip={false}
              qrCodeSuccessCallback={(decodedText: any, decodedResult: any) => {
                onSuccessScan(decodedText, decodedResult);
              }}
            />
          </div>
        )}
        <div
          className={classes.modalContentSwitchButton}
          onClick={() => {
            openManual();
            onClose();
          }}
        >
          {translations('search.manually')}
        </div>
      </div>
    </Modal>
  );
};

export default ScanSampleBarcodeModal;
